import { Validator, RequiredRule } from "devextreme-react/validator";
import { useContext, useState } from "react";
import { useAsync, useAsyncFn } from "react-use";
import LookupEdit from "../../../Component/LookupEdit";
import LoadingIndicator from "../../../Component/LoadingIndicator";
import Field from "../../../Component/Field";
import DateEdit from "../../../Component/DateEdit";
import repositories from "./LeaveRepository";
import Button from "devextreme-react/button";
import TextArea from "devextreme-react/text-area";
import repository from "./LeaveRepository";
import { Alert } from "react-bootstrap";
import { LeaveContext } from "./LeaveContext";
import { RadioGroup } from "devextreme-react/radio-group";
import { CheckBox } from "devextreme-react/check-box";

const typeItems = [
  { id: 0, name: "CUTI" },
  { id: 1, name: "IJIN" },
];
const NewLeaveForm = ({ onClose, title }) => {
  const [dataSource, setDataSource] = useContext(LeaveContext);
  const [employees, setEmployees] = useState([]);
  const [typeID, setTypeID] = useState(0);
  const [salaryDeduction, setSalaryDeduction] = useState(true);
  const EmployeeState = useAsync(async () => {
    const response = await repositories.getEmployees();
    setEmployees(response);
  }, []);

  //const [state, onSubmit] = useAsyncFn(() => {}, []);
  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      employee_id: employee,
      start_date: startDate,
      end_date: endDate,
      desc: desc,
      type: typeID,
      is_deduction: salaryDeduction,
    };
    createNewLeave(data);
  };

  const [saveState, createNewLeave] = useAsyncFn(async (data) => {
    const it = await repository.createNewLeave(data);
    setDataSource([...dataSource, ...it]);
    onClose(title);
  }, []);

  const [employee, setEmployee] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [desc, setDesc] = useState();

  return (
    <div>
      {EmployeeState.loading ? (
        <LoadingIndicator />
      ) : (
        <form id="form" onSubmit={onSubmit} className="sm:w-full md:w-2/3 p-4">
          <Field label="Pegawai">
            <LookupEdit
              onValueChanged={(value) => setEmployee(value)}
              dataSource={employees}
            >
              <Validator>
                <RequiredRule message="test" />
              </Validator>
            </LookupEdit>
          </Field>
          <Field label="Mulai">
            <DateEdit value={startDate} setValue={setStartDate}></DateEdit>
          </Field>

          <Field label="Sampai">
            <DateEdit value={endDate} setValue={setEndDate}></DateEdit>
          </Field>

          <Field label="Keterangan">
            <TextArea onValueChanged={(e) => setDesc(e.value)}>
              <Validator>
                <RequiredRule />
              </Validator>
            </TextArea>
          </Field>
          <Field label="Jenis">
            <RadioGroup
              items={typeItems}
              layout="horizontal"
              valueExpr="id"
              displayExpr="name"
              defaultValue={0}
              onValueChanged={(e) => setTypeID(e.value)}
            />
          </Field>

          {typeID === 1 ? (
            <Field label="">
              <CheckBox
                defaultValue={salaryDeduction}
                onValueChanged={(e) => setSalaryDeduction(e.value)}
                text="Potong Gaji"
              />
            </Field>
          ) : null}
          {saveState.error ? (
            <Alert variant="danger">{saveState.error.message}</Alert>
          ) : null}
          {saveState.loading ? (
            <LoadingIndicator />
          ) : (
            <Button
              id="button"
              text="Simpan"
              type="default"
              useSubmitBehavior={true}
            />
          )}
        </form>
      )}
    </div>
  );
};

export default NewLeaveForm;
